<template>
  <div>
    <section class="section">
        <div class="container is-fluid">
            <div class="columns">
                <div class="column">
                    <h1 class="title">New Search Query</h1>
                    <h2 class="subtitle">
                        Choose sources, product family and filter by device details
                    </h2>
                </div>
                <div class="column is-2" align="right">
                    <button
                        @click="saveSearch()"
                        class="button is-primary">
                        Save Search
                    </button>
                </div>
            </div>
        </div>
    </section>

    <section class="section">
      <div class="container is-fluid">
        <div class="columns">

        <div class="column is-one-fifth">
            <div class="card">
                <div class="card-content">
                <div class="content">
                    <h3>Sources</h3>

                    <p v-if="!validation.sources" class="has-text-danger">Select one or more sources</p>

                    <button
                        v-for="source in this.sources"
                        :key="source.id"
                        @click="sourceSelected(source)"
                        v-bind:class="{'is-primary': source.selected}"
                        class="button selectable-button">
                        {{ source.name }}
                    </button>
                </div>
                </div>
            </div>
        </div>

        <div class="column is-one-fifth">
            <div class="card">
                <div class="card-content">
                <div class="content">
                    <h3>Product Family</h3>

                    <p v-if="!validation.productFamily" class="has-text-danger">Select a product family</p>

                    <button
                    v-for="family in this.productFamilies"
                    :key="family.id"
                    @click="productFamilySelected(family)"
                    v-bind:class="{'is-primary': family.selected}"
                    class="button selectable-button">
                    {{ family.name }}
                    </button>
                </div>
                </div>
            </div>
        </div>

        <div class="column">
            <iPhoneSearchSettings ref="iphoneSettings" v-if="selectedProductFamily.name == 'iPhone'" />
            <MacSearchSettings v-else />

            <PriceRangeSettings ref="priceRangeSettings" class="price-range-card">
              <p v-if="!validation.priceRange" class="has-text-danger">Invalid price range. The <strong class="has-text-danger">from</strong> price should be less than or equal to the <strong class="has-text-danger">to</strong> price</p>
            </PriceRangeSettings>
        </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import MacSearchSettings from "@/components/MacSearchSettings.vue"
import iPhoneSearchSettings from "@/components/iPhoneSearchSettings.vue"
import PriceRangeSettings from "@/components/PriceRangeSettings.vue"

import mockiPhoneListings from '@/assets/data/queries/mock_iphone_listings.json'

export default {
  name: "NewSearchQuery",
  components: {
    MacSearchSettings,
    PriceRangeSettings,
    iPhoneSearchSettings
  },
  data() {
    return {
      sources: [
        {
            id: 1,
            name: "marktplaats.nl",
            selected: false
        },
        {
            id: 2,
            name: "ebay.nl",
            selected: false
        },
        {
            id: 3,
            name: "2dehands.be",
            selected: false
        }
      ],
      selectedProductFamily: {
        // Mock data
        id: -1,
        name: "None",
        selected: false
      },
      productFamilies: [
        {
            id: 1,
            name: "iPhone",
            selected: false
        },
        {
            id: 2,
            name: "iPad",
            selected: false
        },
        {
            id: 3,
            name: "iPod",
            selected: false
        },
        {
            id: 4,
            name: "Mac",
            selected: false
        }
      ],
      validation: {
        sources: true,
        productFamily: true,
        priceRange: true
      }
    }
  },
  methods: {
    sourceSelected (source) {
      source.selected = !source.selected;
    },
    productFamilySelected (productFamily) {
      this.selectedProductFamily = productFamily;
      this.productFamilies.forEach(element =>
        element.selected = element.id == productFamily.id
      );
    },
    validateSources() {
      return this.sources.filter(source => source.selected).length > 0;
    },
    validateProductFamily() {
      return this.productFamilies.filter(family => family.selected).length == 1;
    },
    validatePriceRange() {
      let priceRange = this.$refs.priceRangeSettings.getPriceRange();

      // No price range option specified
      if (priceRange == null) return true;

      return priceRange[0] <= priceRange[1];
    },
    validate() {
      // Update the validation variables (show errors, etc.)
      this.validation.sources = this.validateSources();
      this.validation.productFamily = this.validateProductFamily();
      this.validation.priceRange = this.validatePriceRange();

      // The form is valid if all validation fields are true
      return Object.keys(this.validation).filter(key => !this.validation[key]).length == 0;
    },
    saveSearch() {
      if (!this.validate()) {
        this.$buefy.toast.open({
            duration: 3000,
            message: "Could not save, check the form data and retry",
            position: "is-top",
            type: "is-danger"
        });

        return;
      }

      let query;

      if (this.selectedProductFamily.name == "iPhone") {
        query = this.$refs.iphoneSettings.getQueryParams();
      }

      let selectedSourceNames = this.sources
        .filter(source => source.selected)
        .map(source => source.name);

      // FIXME: This should either come from an API or should
      // be progressive
      query.id = 2;
      query.sources = selectedSourceNames;
      query.listings = mockiPhoneListings;

      let priceRange = this.$refs.priceRangeSettings.getPriceRange()

      if (priceRange !== null) {
        query.priceRange = priceRange;
      }

      // FIXME: mock query
      let currentQueries = JSON.parse(localStorage.queries);
      currentQueries.push(query);

      localStorage.queries = JSON.stringify(currentQueries);

      this.$buefy.toast.open("Query saved");
      this.$router.push({
          name: "dashboard"
      });
    }
  }
};

</script>

<style lang="scss" scoped>

.selectable-button {
    width: 100%;
    margin-bottom: 16px;
}

.price-range-card {
  margin-top: 24px;
}

</style>